import { filtersHelper } from '@/utils';
import { propertyModel } from '@/models/api/property.model';
import { propertyAreaUnitModel } from '@/models/api/propertyAreaUnit.model';
import { propertyTenureModel } from '@/models/api/propertyTenure.model';
import { propertyCategoryModel } from '@/models/api/propertyCategory.model';
import { propertyActionModel } from '@/models/api/propertyAction.model';
import { propertyStatusModel } from '@/models/api/propertyStatus.model';
import { propertyAssetTenantModel } from '@/models/api/propertyAssetTenant.model';

export const propertyAssetModel = (data) => ({
    ...propertyModel(data),
    asset: data.property_asset ? {
        uuid: data.property_asset.uuid,
        fileId: data.property_asset.file_id,
        lotId: data.property_asset.lot_id,
        hakMilikId: data.property_asset.hak_milik_id,
        purchaseDate: data.property_asset.purchase_date,
        purchaseValuePsf: data.property_asset.purchase_value_psf,
        purchaseValueTotal: data.property_asset.purchase_value_total,
        nbvValue: data.property_asset.nbv_value,
        revaluationDate: data.property_asset.revaluation_date,
        revaluationValuePsf: data.property_asset.revaluation_value_psf,
        revaluationValueTotal: data.property_asset.revaluation_value_total,
        soldPrice: data.property_asset.sold_price,
        yield: data.property_asset.yield,
        buildingSize: data.property_asset.building_size,
        buildingSizeUnit: data.property_asset.building_size_unit ? propertyAreaUnitModel(data.property_asset.building_size_unit) : null,
        landSize: data.property_asset.land_size,
        landSizeUnit: data.property_asset.land_size_unit ? propertyAreaUnitModel(data.property_asset.land_size_unit) : null,
        utilizeBuildingSize: data.property_asset.utilize_building_size,
        utilizeBuildingSizeUnit: data.property_asset.utilize_building_size_unit ? propertyAreaUnitModel(data.property_asset.utilize_building_size_unit) : null,
        utilizeBuildingPercentage: data.property_asset.utilize_building_percentage,
        utilizeLandSize: data.property_asset.utilize_land_size,
        utilizeLandSizeUnit: data.property_asset.utilize_land_size_unit ? propertyAreaUnitModel(data.property_asset.utilize_land_size_unit) : null,
        utilizeLandPercentage: data.property_asset.utilize_land_percentage,
        marketValue: data.property_asset.market_value,
        estimatedRental: data.property_asset.estimated_rental,
        estimatedRentalMonthly: data.property_asset.estimated_rental_monthly,
        estimatedRentalYearly: data.property_asset.estimated_rental_yearly,
        leaseHoldExpiredDate: data.property_asset.lease_hold_expired_date,
        leaseYear: data.property_asset.lease_year,
        leaseYearRemaining: data.property_asset.lease_year_remaining,
        bandarPekanMukim: data.property_asset.bandar_pekan_mukim,
        grade: data.property_asset.grade,
        isCompliance: data.property_asset.is_compliance,
        isActive: data.property_asset.is_active,
        createdAt: filtersHelper.getDateFormat(data.property_asset.created_at),
        createdBy: data.property_asset.created_by,
        updatedAt: filtersHelper.getDateFormat(data.property_asset.updated_at),
        updatedBy: data.property_asset.updated_by,
        deletedAt: filtersHelper.getDateFormat(data.property_asset.deleted_at),
        deletedBy: data.property_asset.deleted_by,
        propertyTenure: data.property_asset.property_tenure ? propertyTenureModel(data.property_asset.property_tenure) : null,
        propertyCategory: data.property_asset.property_category ? propertyCategoryModel(data.property_asset.property_category) : null,
        propertyStatus: data.property_asset.property_status ? propertyStatusModel(data.property_asset.property_status) : null,
        propertyAction: data.property_asset.property_action ? propertyActionModel(data.property_asset.property_action) : null,
        propertyAssetTenants: (data.property_asset.property_asset_tenants ?? []).map((item) => propertyAssetTenantModel(item)),
    } : null,
});